<template>
  <div class="container-fluid" style="padding: 20px 0">
    <div class="row">
      <div class="col">
        <div class="page-title m-plus-medium">スクリプト実行</div>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-3">
        <div style="padding-top: 5px">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">シェア用のUsers再構築</h5>
              <p>
                UsersのデータをSHareUsersへコピペする<br />
                ※一度ShareUsersを削除する
              </p>
              <div class="d-grid gap-2">
                <a href="#" @click="script1" class="btn btn-primary">
                  スクリプト実行
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "../../plugins/firebase";
import { collection, getDocs, doc, setDoc } from "firebase/firestore";
export default {
  data() {
    return {};
  },
  methods: {
    async script1() {
      const querySnapshot = await getDocs(collection(db, "users"));

      const updatePromises = querySnapshot.docs.map(async (docSnapshot) => {
        const data = docSnapshot.data();
        await setDoc(doc(db, "shareUsers", docSnapshot.id), {
          uid: data.uid == undefined ? null : data.uid,
          age: data.age == undefined ? null : data.age,
          area: data.area == undefined ? null : data.area,
          isAppointment:
            data.isAppointment == undefined ? null : data.isAppointment,
          selectStore: data.selectStore == undefined ? null : data.selectStore,
          selectStoreName:
            data.selectStoreName == undefined ? null : data.selectStoreName,
          selectStoreImage:
            data.selectStoreImage == undefined ? null : data.selectStoreImage,
          birthday: data.birthday == undefined ? null : data.birthday,
          comment: data.comment == undefined ? null : data.comment,
          isIconImage: data.isIconImage == undefined ? null : data.isIconImage,
          isTagBlue: data.isTagBlue == undefined ? null : data.isTagBlue,
          isTagCyan: data.isTagCyan == undefined ? null : data.isTagCyan,
          isTagGreen: data.isTagGreen == undefined ? null : data.isTagGreen,
          isTagOrange: data.isTagOrange == undefined ? null : data.isTagOrange,
          isTagPurple: data.isTagPurple == undefined ? null : data.isTagPurple,
          isTagRed: data.isTagRed == undefined ? null : data.isTagRed,
          isTagYellow: data.isTagYellow == undefined ? null : data.isTagYellow,
          like: data.LikeText == undefined ? null : data.LikeText,
          masochist: data.masochist == undefined ? null : data.masochist,
          name: data.name == undefined ? null : data.name,
          ng: data.NGText == undefined ? null : data.NGText,
          profile: data.ProfileText == undefined ? null : data.ProfileText,
          question1: data.question1 == undefined ? null : data.question1,
          question10: data.question10 == undefined ? null : data.question10,
          question11: data.question11 == undefined ? null : data.question11,
          question12: data.question12 == undefined ? null : data.question12,
          question13: data.question13 == undefined ? null : data.question13,
          question14: data.question14 == undefined ? null : data.question14,
          question15: data.question15 == undefined ? null : data.question15,
          question16: data.question16 == undefined ? null : data.question16,
          question17: data.question17 == undefined ? null : data.question17,
          question18: data.question18 == undefined ? null : data.question18,
          question19: data.question19 == undefined ? null : data.question19,
          question2: data.question2 == undefined ? null : data.question2,
          question20: data.question20 == undefined ? null : data.question20,
          question21: data.question21 == undefined ? null : data.question21,
          question22: data.question22 == undefined ? null : data.question22,
          question23: data.question23 == undefined ? null : data.question23,
          question24: data.question24 == undefined ? null : data.question24,
          question25: data.question25 == undefined ? null : data.question25,
          question26: data.question26 == undefined ? null : data.question26,
          question27: data.question27 == undefined ? null : data.question27,
          question28: data.question28 == undefined ? null : data.question28,
          question29: data.question29 == undefined ? null : data.question29,
          question3: data.question3 == undefined ? null : data.question3,
          question30: data.question30 == undefined ? null : data.question30,
          question31: data.question31 == undefined ? null : data.question31,
          question32: data.question32 == undefined ? null : data.question32,
          question33: data.question33 == undefined ? null : data.question33,
          question34: data.question34 == undefined ? null : data.question34,
          question35: data.question35 == undefined ? null : data.question35,
          question36: data.question36 == undefined ? null : data.question36,
          question37: data.question37 == undefined ? null : data.question37,
          question38: data.question38 == undefined ? null : data.question38,
          question39: data.question39 == undefined ? null : data.question39,
          question4: data.question4 == undefined ? null : data.question4,
          question40: data.question40 == undefined ? null : data.question40,
          question41: data.question41 == undefined ? null : data.question41,
          question42: data.question42 == undefined ? null : data.question42,
          question43: data.question43 == undefined ? null : data.question43,
          question44: data.question44 == undefined ? null : data.question44,
          question45: data.question45 == undefined ? null : data.question45,
          question46: data.question46 == undefined ? null : data.question46,
          question47: data.question47 == undefined ? null : data.question47,
          question48: data.question48 == undefined ? null : data.question48,
          question49: data.question49 == undefined ? null : data.question49,
          question5: data.question5 == undefined ? null : data.question5,
          question50: data.question50 == undefined ? null : data.question50,
          question51: data.question51 == undefined ? null : data.question51,
          question52: data.question52 == undefined ? null : data.question52,
          question53: data.question53 == undefined ? null : data.question53,
          question54: data.question54 == undefined ? null : data.question54,
          question55: data.question55 == undefined ? null : data.question55,
          question56: data.question56 == undefined ? null : data.question56,
          question57: data.question57 == undefined ? null : data.question57,
          question58: data.question58 == undefined ? null : data.question58,
          question59: data.question59 == undefined ? null : data.question59,
          question6: data.question6 == undefined ? null : data.question6,
          question60: data.question60 == undefined ? null : data.question60,
          question61: data.question61 == undefined ? null : data.question61,
          question62: data.question62 == undefined ? null : data.question62,
          question63: data.question63 == undefined ? null : data.question63,
          question64: data.question64 == undefined ? null : data.question64,
          question65: data.question65 == undefined ? null : data.question65,
          question66: data.question66 == undefined ? null : data.question66,
          question67: data.question67 == undefined ? null : data.question67,
          question68: data.question68 == undefined ? null : data.question68,
          question69: data.question69 == undefined ? null : data.question69,
          question7: data.question7 == undefined ? null : data.question7,
          question70: data.question70 == undefined ? null : data.question70,
          question8: data.question8 == undefined ? null : data.question8,
          question9: data.question9 == undefined ? null : data.question9,
          sadistic: data.sadistic == undefined ? null : data.sadistic,
          active: data.active == undefined ? null : data.active,
          passive: data.passive == undefined ? null : data.passive,
          sukebe: data.sukebe == undefined ? null : data.sukebe,
          selectedAlcohol:
            data.selectedAlcohol == undefined ? null : data.selectedAlcohol,
          selectedBloods:
            data.selectedBloods == undefined ? null : data.selectedBloods,
          selectedBodyHight:
            data.selectedBodyHight == undefined ? null : data.selectedBodyHight,
          selectedBodyType:
            data.selectedBodyType == undefined ? null : data.selectedBodyType,
          selectedDirectional:
            data.selectedDirectional == undefined
              ? null
              : data.selectedDirectional,
          selectedGender:
            data.selectedGender == undefined ? null : data.selectedGender,
          selectedPersonality:
            data.selectedPersonality == undefined
              ? null
              : data.selectedPersonality,
          selectedSmoking:
            data.selectedSmoking == undefined ? null : data.selectedSmoking,
          selectTag: data.selectTag == undefined ? null : data.selectTag,
          selectedKaiwais:
            data.selectedKaiwais == undefined ? null : data.selectedKaiwais,
          selectedNoteKaiwai:
            data.selectedNoteKaiwai == undefined
              ? null
              : data.selectedNoteKaiwai,
          sex: data.sex == undefined ? null : data.sex,
          weburl: data.weburl == undefined ? null : data.weburl,
        });
      });

      // すべての更新が完了するのを待つ
      await Promise.all(updatePromises);
      console.log("end");
      this.$toast.show("おわり", {
        position: "bottom",
        duration: 2000,
      });
    },
  },
};
</script>

<style scoped>
.page-title {
  font-size: 30px;
  font-weight: bold;
  color: #827490;
}
</style>
